// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"282":"29781f28","592":"5c9795f5","900":"325e6cf1"}[chunkId] + ".chunk.js";
};